module.exports = __webpack_public_path__ + "static/media/rule_black_24dp.ad2bd8f0.svg";